import React, { Component } from 'react';
import $ from "jquery"
import('./Organization.css');


class Organization extends Component {


  componentDidMount() {
    $('#organization').css('right', '50px')
  }

  componentWillReceiveProps(nextProps) {
    $('#organization').css('right', '50px')
  }

  closeOrganization(e) {
    e.preventDefault()
    $('#organization').css('right', '-680px')
  }

  numberWithCommas(x) {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }


  render() {
    console.log(this.props)
    return(
      <div id="organization">
       <div className="organization--close">
        <a href="#close" onClick={ (e) => this.closeOrganization(e) }>x</a>
       </div>
       <div className="organization--title">
          { this.props.data.title }
        </div>
       <div className="organization--facility">
        <div className="col-1">
        { this.props.data.parent !== '' &&
        <div>
        <div className="organization--field-label">
          Workspace
        </div>
        <div className="organization--field">
          { this.props.data.field_workspace_title }
        </div>
        </div>
        }
        <div className="organization--field-label">
          Address
        </div>
        <div className="organization--field">
         { this.props.data.field_street_address }
         { ' ' + this.props.data.field_address_line_2 }<br/>
         { this.props.data.field_city }<br/>
         { this.props.data.field_zip }<br/>
         { this.props.data.field_state }
        </div>
        { this.props.data.field_website !== '' &&
        <div>
        <div className="organization--field-label">
          Organization Website
        </div>
        <div className="organization--field">
         <a href={ this.props.data.field_website } rel="noopener noreferrer" target="_blank">{ this.props.data.field_website }</a>
        </div>
        </div>
        }
        { this.props.data.field_year_founded !== '' &&
        <div>
        <div className="organization--field-label">
          Year Founded
        </div>
        <div className="organization--field">
         { this.props.data.field_year_founded }
        </div>
        </div>
        }
        { this.props.data.term_node_tid !== '' &&
        <div>
        <div className="organization--field-label">
          Programming
        </div>
        <div className="organization--field">
         { this.props.data.term_node_tid }
        </div>
        </div>
        }
        </div>


        <div className="col-2">
        { this.props.data.field_foundation_contributions !== '' &&
        <div>
        <div className="organization--field-label">
          Foundation contributions
        </div>
        <div className="organization--field">
         { this.props.data.field_foundation_contributions }
        </div>
        </div>
        }
        { this.props.data.field_government_support !== '' &&
        <div>
        <div className="organization--field-label">
          Government support
        </div>
        <div className="organization--field">
         { this.props.data.field_government_support }
        </div>
        </div>
        }
        { isNaN(this.props.data.field_square_footage) === false &&
        <div>
        <div className="organization--field-label">
          Total Square Footage
        </div>
        <div className="organization--field">
         { this.numberWithCommas(this.props.data.field_square_footage) }
        </div>
        </div>
        }
        { this.props.data.field_offers_rentals !== 'No' &&
        <div>
        <div className="organization--field-label">
          Rents space
        </div>
        <div className="organization--field">
         { this.props.data.field_offers_rentals }
        </div>
        </div>
        }
        { this.props.data.field_updated_at !== '' &&
        <div>
        <div className="organization--field-label">
          Last updated
        </div>
        <div className="organization--field">
         { this.props.data.field_updated_at }
        </div>
        </div>
        }
        { this.props.data.field_city_owned !== 'No' &&
        <div>
        <div className="organization--field-label">
          City Owned
        </div>
        <div className="organization--field">
         { this.props.data.field_city_owned }
        </div>
        </div>
        }
        { this.props.data.field_city_department !== '' &&
        <div>
        <div className="organization--field-label">
          Department
        </div>
        <div className="organization--field">
         { this.props.data.field_city_department }
        </div>
        </div>
        }
        { this.props.data.field_city_owned !== 'Yes' &&
        <div>
        <div className="organization--field-label">
          Non-Profit
        </div>
        <div className="organization--field">
          Yes
        </div>
        </div>
        }
        </div>


       </div>
      </div>
    )
  }

}

export default Organization



// WEBPACK FOOTER //
// ./src/components/Organization/Organization.js